module.exports = __webpack_public_path__ + "static/media/brush_2.3c338e48.png";